<template>
  <a-card class="m-t-10" :bordered='false'>
    <a-button size='small' @click="()=>{$router.go(-1)}">
      <LeftOutlined />返回
    </a-button>
    <span class="ml15 card_title">应用购买</span>
  </a-card>
  <a-card :bordered='false' class="p-20">
    <a-steps v-model:current="current" size="small">
      <a-step status="finish" disabled title="确认订单" />
      <a-step :status="orderDetail.pay_status==1?'':'finish'" disabled title="支付" />
      <a-step :status="orderDetail.pay_status==1?'Waiting':'finish'" disabled title="支付成功" />
    </a-steps>
    <a-card class="p-l-20 p-r-20 m-t-40">
      <div class="top p-b-10" style="border-bottom:1px solid #eee">
        <p class="fz-26 s_font_b">
          <CheckCircleOutlined class='fz-20' v-if="orderDetail.pay_status!=1" />
          <AccountBookOutlined class='fz-20' v-else />
          {{orderDetail.pay_status==1?'待付款':'已完成'}}
        </p>
        <p class="s_c999">下单时间：{{orderDetail.create_time}}</p>
      </div>
      <div class="bottom m-t-10 p-b-10">
        <div class='s_c999'><span
            class='label text-ar ds-i-b width-70 fz-14 s_c333 m-b-10'>商户账号：</span>{{orderDetail.account}}</div>
        <div class='s_c999'><span
            class='label text-ar ds-i-b width-70 fz-14 s_c333 m-b-10'>订单号：</span>{{orderDetail.order_no}} </div>
        <div class='s_c999'><span
            class='label text-ar ds-i-b width-70 fz-14 s_c333 m-b-10'>产品：</span>{{orderDetail.ref_name}} </div>
      </div>
      <div class="foot text-ar p-t-10">
        合计：<span class="s_cd41">{{orderDetail.pay_price}} </span>
      </div>
    </a-card>
    <a-card :bordered='false' class="p-20">
      <a-tabs>
        <a-tab-pane key="1" tab="扫描支付">
          <div style="height:400px">
            <div class='s_flex_ali m-b-15'>
              <img :src="codeUrl" alt="">
              <div style="width:300px" class=''>
                <div class="s_flex_center m-b-15">
                  <div class="m-r-20 s_flex_center">
                    <WechatOutlined class="fz-20" style="color:rgb(12, 188, 10)" />微信支付
                  </div>
                  <div class='s_flex_center'>
                    <AlipayCircleOutlined class="fz-20" style="color:rgb(11, 173, 239)" />支付宝支付
                  </div>
                </div>
                <p class="fz-22 s_font_b text-ac m-b-130">扫一扫完成支付</p>
                <p class=" s_font_b text-ac">
                  <a-button type="primary" v-has:orderAppsPayNow="checkPay">支付成功</a-button>
                </p>
              </div>
            </div>
          </div>
        </a-tab-pane>
        <a-tab-pane key="2" tab="使用余额支付" force-render>
          <div style="height:400px">
            <p class="m-b-20">余额：<span class="s_cd41">{{info.overView.balance}}</span></p>
            <a-button type="primary" v-has:orderAppsPayNow='balancePlay'>余额支付</a-button>
          </div>
        </a-tab-pane>
        <!-- <a-tab-pane key="3" tab="线下转账支付">
          <div style="height:400px">
            <p>转账成功后请点击下方上传打款凭证按钮,并填写相应的信息,我们会在1-3个工作日内审核,审核成功</p>
            <p>您需要转载<span class="s_cd41">10000</span>至一下账户: </p>
            <p> 收款账户名: </p>
            <p> 收款方开户行: </p>
            <p> 收款方账号:xxx </p>
             <a-button type="primary">上传凭证</a-button>
          </div>
        </a-tab-pane> -->
      </a-tabs>
    </a-card>
  </a-card>
</template>
<script>
  import { inject, onUnmounted, reactive, ref, toRefs } from "vue";
  import { getAppOrder, getPayCode, payForBalance } from "@/api/orderApps";
  import {
    AccountBookOutlined,
    CheckCircleOutlined,
    WechatOutlined,
    AlipayCircleOutlined,
    LeftOutlined
  } from "@ant-design/icons-vue";
  import { iscode } from "@/utils/app";
  import { message, Modal } from 'ant-design-vue';
  import store from '@/store'
  const def = {
    order_no: "",
  };
  export default {
    components: {
      AccountBookOutlined,
      CheckCircleOutlined,
      WechatOutlined,
      AlipayCircleOutlined,
      LeftOutlined
    },
    setup() {
      const state = reactive({
        current: 1,
        codeUrl: "",
        orderDetail: {},
        info: store.state.user.info,
      });
      const $route = inject("$route");
      const $router = inject('$router')
      // 初始化数据

      const initData = async (values) => {
        let code = await getPayCode({ order_no: $route.query.order_no }).then((res) => res.data).catch((error) => error);
        if (iscode(code)) {
          state.codeUrl = code.data.image;
        }
        let result = await getAppOrder({ order_no: $route.query.order_no }).then(res => res.data).catch(error => error)
        if (iscode(result)) {
          state.orderDetail = result.data
        }
      };
      initData();
      const balancePlay = () => {
        Modal.confirm({
          title:'提示',
          centered: true,
          content: "确定要使用余额支付么？",
          onOk: async () => {
            let res = await payForBalance({ order_no: $route.query.order_no }).then((res) => res.data);
            if (iscode(res, true)) {
                $router.go(-1)
            }
          },
        });
      }
      const checkPay=()=>{

      }
      return {
        ...toRefs(state),
        balancePlay,
        checkPay
      };
    },
  };
</script>